module.exports = __webpack_public_path__ + "static/media/non-disclusore-green.0fd69b59.svg";